import { BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

import {
  EXTERNAL_PARTNERS_AND_ADVISERS_NAMES,
  WORK_EXPERIENCE_NAMES as EXTERNAL_PARTNERS_WORK_EXPERIENCE_NAMES,
  LIST_OF_EXTERNAL_PARTNERS_NAMES,
} from 'components/BusinessToolForm/Sections/ManagementAndOrganization/ExternalPartners/utils/form';
import {
  INSTITUTION_NAMES,
  MANAGEMENT_TEAM_NAMES,
  PERSONNEL_PROFILES_NAMES,
  WORK_EXPERIENCE_NAMES,
} from 'components/BusinessToolForm/Sections/ManagementAndOrganization/ManagementTeam/utils/form';
import {
  LEVEL2_DEPARTMENT_NAMES,
  LEVEL3_DEPARTMENT_NAMES,
  STAFF_ORGANIZATION_NAMES,
} from 'components/BusinessToolForm/Sections/ManagementAndOrganization/StaffOrganization/utils/form';

import { ul } from '../helpers';

const LIST_OF_INSTITUTIONS_INSTRUCTIONS = {
  [INSTITUTION_NAMES.NAME]: {
    name: 'Назва закладу освіти',
    instruction: 'Укажіть повні назви навчальних закладів, у яких навчалися ключові співробітники',
    exampleOne: 'Американський університет',
    exampleTwo: 'Університет штату Оклахома',
  },
  [INSTITUTION_NAMES.SPECIALIZATION]: {
    name: 'Спеціалізація',
    instruction: 'Укажіть спеціалізацію або основну спеціальність, здобуту під час навчання ключового персоналу',
    exampleOne: 'Інженерія',
    exampleTwo: 'Фінанси',
  },
};

const WORK_EXPERIENCE_INSTRUCTIONS = {
  [WORK_EXPERIENCE_NAMES.EMPLOYER]: {
    name: 'Назва роботодавця',
    instruction: 'Чітко вкажіть повну назву роботодавця або організації',
    exampleOne: 'John Deere',
    exampleTwo: 'ARP Dend',
  },
  [WORK_EXPERIENCE_NAMES.POSITION]: {
    name: 'Посада',
    instruction:
      'Укажіть посаду, яку обіймав ключовий співробітник в організації, стисло та чітко підкресливши роль і відповідальність',
    exampleOne: 'Головний інженер відділу агропромислового розвитку',
    exampleTwo: 'Фінансовий менеджер',
  },
  [WORK_EXPERIENCE_NAMES.FROM]: {
    name: 'Період',
    instruction: 'Надайте детальну хронологію трудового стажу, включно з періодами роботи',
    exampleOne: '2000',
    exampleTwo: '2017',
  },
  [WORK_EXPERIENCE_NAMES.TO]: {
    name: 'Період',
    instruction: 'Надайте детальну хронологію трудового стажу, включно з періодами роботи',
    exampleOne: '2013',
    exampleTwo: '2023',
  },
  [WORK_EXPERIENCE_NAMES.FUNCTIONS]: {
    name: 'Функції',
    instruction:
      'Опишіть обов’язки та напрями роботи, в яких був залучений співробітник. Підкресліть значущість його дій для досягнення цілей організації.',
    exampleOne:
      'Формування та реалізація технологічної стратегії компанії відповідно до її загальних бізнес-цілей. Керівництво дослідницькими та конструкторськими роботами для інновацій та покращення продуктового портфеля.',
    exampleTwo:
      'Розробка й підтримка фінансових моделей для прогнозування фінансових показників компанії. Аналіз фінансових даних для виявлення тенденцій доходів, структури витрат та прибутковості. Оцінка фінансових ризиків компанії й розробка стратегій їхньої мінімізації.',
  },
};

const PERSONNEL_PROFILES_INSTRUCTIONS = {
  [PERSONNEL_PROFILES_NAMES.FILE]: {
    name: '',
    instruction:
      'Завантажте зображення у високій роздільній здатності, яке відповідає професійним стандартам і бренду компанії.',
    exampleOne: '',
    exampleTwo: '',
  },
  [PERSONNEL_PROFILES_NAMES.NAME]: {
    name: "Ім'я",
    instruction: 'Укажіть ім’я ключового співробітника в форматі: Ім’я, а потім Прізвище',
    exampleOne: 'Олівер',
    exampleTwo: 'Мері',
  },
  [PERSONNEL_PROFILES_NAMES.SURNAME]: {
    name: 'Прізвище',
    instruction: 'Укажіть ім’я ключового співробітника в форматі: Ім’я, а потім Прізвище',
    exampleOne: 'Сміт',
    exampleTwo: 'Вілсон',
  },
  [PERSONNEL_PROFILES_NAMES.DATE_OF_BIRTH]: {
    name: 'Дата народження',
    instruction: 'Укажіть дату народження у зрозумілому форматі, включно з днем, місяцем і роком',
    exampleOne: '01.01.1975',
    exampleTwo: '02.05.1983',
  },
  [PERSONNEL_PROFILES_NAMES.POSITION]: {
    name: 'Поточна посада',
    instruction:
      'Укажіть посаду, яку обіймає ключовий співробітник в організації.',
    exampleOne: 'Головний технічний директор',
    exampleTwo: 'Фінансовий менеджер',
  },
  [PERSONNEL_PROFILES_NAMES.LIST_OF_INSTITUTIONS]: LIST_OF_INSTITUTIONS_INSTRUCTIONS,
  [PERSONNEL_PROFILES_NAMES.WORK_EXPERIENCE]: WORK_EXPERIENCE_INSTRUCTIONS,
  [PERSONNEL_PROFILES_NAMES.KEY_SKILLS]: {
    name: 'Ключові навички',
    instruction:
      'Перерахуйте критично важливі навички для успішної роботи на керівній посаді. Підкресліть компетенції, що підтверджують здатність ефективно виконувати покладені обов’язки.',
    exampleOne: ul([
      'Машинобудування',
      'Проектування сільськогосподарської техніки',
      'Управління проектами',
      'Лідерство',
      'Технічне вирішення проблем',
    ]),
    exampleTwo: ul([
      'Фінансове планування та аналіз',
      'Бюджетування',
      'Прогнозування',
      'Фінансова звітність',
      'Вирішення фінансових проблеми',
    ]),
  },
  [PERSONNEL_PROFILES_NAMES.ACHIEVEMENTS]: {
    name: 'Особливі досягнення',
    instruction:
      'Надайте огляд ключових досягнень у відповідній сфері. Чітко визначте експертизу або спеціалізацію, що вирізняє цю особу. Опишіть найважливіші результати, кваліфікації чи віхи, які демонструють високий рівень професіоналізму.',
    exampleOne:
      'У John Deere він відіграв ключову роль у розробці двигунів для ескалаторів Jan85. Щорічно бере участь у міжнародних виставках техніки, включно з International EXPO та Innovation у Чикаго. П’ять років поспіль очолює рейтинг «Перспективні інженери Коннектикуту».',
    exampleTwo:
      'Сертифікований Chartered Financial Analyst (CFA). Mary відзначена за видатний вклад у сферу фінансів, отримавши престижні нагороди Financial Excellence Award 2020 та Finance Professional of the Year Award 2021.',
  },
};

const MANAGEMENT_TEAM_INSTRUCTIONS = {
  [MANAGEMENT_TEAM_NAMES.HISTORY]: {
    name: 'Історія та передумови формування команди',
    instruction:
      'Опишіть історію формування управлінської команди. Розкажіть, як формувалася команда, основні етапи, ролі, бекграунд та внесок кожного учасника. Підкресліть експертизу та досвід, які привносить кожен член команди.',
    exampleOne:
      'Компанію заснували американці Джон Джонсон та Олівер Сміт. Джон Джонсон — власник невеликої аграрної компанії в Техасі, а Олівер Сміт — інженер компанії John Deere, відомого виробника сільськогосподарської, будівельної та лісозаготівельної техніки.',

    exampleTwo:
      'Критичними учасниками проекту в Компанії є Джон Джонсон та Мері Вілсон. Компанію заснував Джон Джонсон, випускник Університету А за спеціальністю програмування. Він об’єднався з Мері Вілсон, випускницею того ж університету за спеціальністю фінанси, щоб запустити бізнес.',
  },
  [MANAGEMENT_TEAM_NAMES.SKILLS]: {
    name: 'Навички та компетенції',
    instruction:
      'Опишіть ключові навички та компетенції управлінської команди. Підкресліть лідерські та професійні якості, які роблять її здатною ефективно керувати бізнесом. Сфокусуйтеся на сильних сторонах, що сприяють успіху компанії.',
    exampleOne:
      'Широкий галузевий досвід команди, а також навички управління бізнесом і адміністративні компетенції роблять її ефективними лідерами. Підприємницьке чуття та галузеві знання Джона Джонсона у поєднанні з технічною експертизою Олівера Сміта формують основу стратегічного розвитку та продуктових інновацій.',

    exampleTwo:
      'Програмні навички Джона Джонсона лежать в основі платформи. Він також спроєктував архітектуру першої версії. Досвід Мері Вілсон у фінансових відділах різних компаній суттєво посилив її компетенції в управлінні фінансами.',
  },
  [MANAGEMENT_TEAM_NAMES.PERSONAL_QUALITIES]: {
    name: 'Особисті якості',
    instruction:
      'Опишіть особисті якості членів команди, зосереджуючись на soft skills, адаптивності, стійкості та умінні співпрацювати. Підкресліть якості, що критично важливі для досягнення цілей організації та підтримки конкурентних переваг.',
    exampleOne:
      'Управлінська команда поєднує в собі лідерські та професійні якості. Керування компанією під час пандемії COVID-19 продемонструвало важливість адаптивності до зовнішніх факторів. Розвинені soft skills допомогли ефективно управляти персоналом у кризових умовах та знаходити рішення нових викликів.',
    exampleTwo:
      'Стійкість, адаптивність, командна співпраця та інноваційність є ключовими особистими якостями команди Компанії. Вони формують динамічне робоче середовище та дають змогу долати виклики, приймати зміни й постійно вдосконалювати операції та рішення.',
  },
  [MANAGEMENT_TEAM_NAMES.PERSONNEL_PROFILES]: PERSONNEL_PROFILES_INSTRUCTIONS,
};

const EXTERNAL_PARTNERS_WORK_EXPERIENCE_INSTRUCTIONS = {
  [EXTERNAL_PARTNERS_WORK_EXPERIENCE_NAMES.EMPLOYER]: {
    name: 'Назва роботодавця',
    instruction: 'Чітко вкажіть повну назву роботодавця або організації',
    exampleOne: 'Лінт',
    exampleTwo: 'A&Partners',
  },
  [EXTERNAL_PARTNERS_WORK_EXPERIENCE_NAMES.POSITION]: {
    name: 'Посада',
    instruction:
      'Укажіть посаду, яку обіймали ключові партнери в організації, стисло та чітко підкресливши роль і обов’язки',
    exampleOne: 'Розробник програмного забезпечення',
    exampleTwo: 'Адвокат з договорів',
  },
};

const LIST_OF_EXTERNAL_PARTNERS_INSTRUCTIONS = {
  [LIST_OF_EXTERNAL_PARTNERS_NAMES.FILE]: {
    name: '',
    instruction:
      'Завантажте зображення у високій роздільній здатності, яке відповідає професійним стандартам і бренду компанії.',
    exampleOne: '',
    exampleTwo: '',
  },
  [LIST_OF_EXTERNAL_PARTNERS_NAMES.NAME]: {
    name: "Ім'я",
    instruction: 'Укажіть ім’я ключових партнерів у форматі: Ім’я, а потім Прізвище',
    exampleOne: 'Алекс',
    exampleTwo: 'Каміла',
  },
  [LIST_OF_EXTERNAL_PARTNERS_NAMES.SURNAME]: {
    name: 'Прізвище',
    instruction: 'Укажіть ім’я ключових партнерів у форматі: Ім’я, а потім Прізвище',
    exampleOne: 'Лето',
    exampleTwo: 'Девіс',
  },
  [LIST_OF_EXTERNAL_PARTNERS_NAMES.ROLE]: {
    name: 'Роль у компанії',
    instruction:
      'Укажіть посаду або роль ключових партнерів в організації.',
    exampleOne: 'IT консультант',
    exampleTwo: 'Юрисконсульт',
  },
  [LIST_OF_EXTERNAL_PARTNERS_NAMES.WORK_EXPERIENCE]: EXTERNAL_PARTNERS_WORK_EXPERIENCE_INSTRUCTIONS,
  [LIST_OF_EXTERNAL_PARTNERS_NAMES.KEY_SKILLS]: {
    name: 'Ключові навички',
    instruction:
      'Перерахуйте ключові навички ваших консультантів. Підкресліть компетенції, які демонструють їхню ефективність у дорученій ролі.',
    exampleOne: 'ІТ-стратегія та планування \nКібербезпека \nРозробка програмного забезпечення',
    exampleTwo: 'Відповідність законодавству \nЗахист інтелектуальної власності \nЮридичне навчання та освіта',
  },
};

const EXTERNAL_PARTNERS_AND_ADVISERS_INSTRUCTIONS = {
  [EXTERNAL_PARTNERS_AND_ADVISERS_NAMES.LIST_OF_EXTERNAL_PARTNERS]: LIST_OF_EXTERNAL_PARTNERS_INSTRUCTIONS,
  [EXTERNAL_PARTNERS_AND_ADVISERS_NAMES.PARTNERS]: {
    name: 'Експертиза партнерів',
    instruction:
      'Перерахуйте всіх партнерів і консультантів, з якими співпрацює компанія. Укажіть, у якій сфері кожен партнер надає експертизу, та підкресліть їхню роль у досягненні цілей компанії. Чітко покажіть, як навички партнерів приносять користь бізнесу.',
    exampleOne:
      'Компанія співпрацює з IT-консультантами ABCD, які мають експертизу в IT-інфраструктурі, кібербезпеці та розробці програмного забезпечення. ABCD допомагає компанії впроваджувати та підтримувати надійні IT-системи й рішення.',
    exampleTwo:
      'Компанія працює з юридичним радником Camila Davis для забезпечення відповідності законодавчим вимогам і мінімізації юридичних ризиків. Маркетингова агенція ABC має експертизу в цифровому маркетингу, брендингу й рекламі, допомагаючи компанії досягати цільової аудиторії.',
  },
  [EXTERNAL_PARTNERS_AND_ADVISERS_NAMES.CRITERIA]: {
    name: 'Критерії відбору',
    instruction:
      'Сформулюйте критерії, за якими обираються зовнішні партнери, такі як успішні проєкти, відгуки клієнтів, сумісність, репутація в галузі або відповідність цілям компанії. Підкресліть, що консультанти володіють специфічними знаннями та навичками, необхідними для цінного внеску в проєкт.',
    exampleOne:
      'Найважливішим критерієм вибору партнерів є експертиза та досвід. Партнери повинні мати спеціалізовані знання та тривалий досвід у відповідних напрямах.',
    exampleTwo:
      'Під час вибору партнерів Компанія враховує їхній досвід, репутацію та економічну доцільність. Партнери повинні пропонувати конкурентні ціни та рентабельні рішення, що відповідають бюджету Компанії. Також важливо, щоб партнери були надійними, дотримувалися строків, виконували зобов’язання та забезпечували конфіденційність.',
  },
  [EXTERNAL_PARTNERS_AND_ADVISERS_NAMES.PLANS]: {
    name: 'Плани розширення',
    instruction:
      'Опишіть наміри розширити пул партнерів і консультантів, обґрунтуйте це бажанням вийти на нові ринки, посилити експертизу чи диверсифікувати погляди. Підкресліть потенційні вигоди та узгодження з стратегічними цілями компанії.',
    exampleOne:
      'Компанія планує розширити мережу партнерів та консультантів, щоб отримати доступ до різноманітної експертизи та поглядів. Це має посилити стратегічне ухвалення рішень і підвищити загальну ефективність бізнесу.',
    exampleTwo:
      'Компанія планує залучити фінансового радника з інвестиційного фонду для оптимізації фінансових процесів і подальшого ефективного управління борговими зобов’язаннями.',
  },
};

const LEVEL2_DEPARTMENT_INSTRUCTIONS = {
  [LEVEL2_DEPARTMENT_NAMES.DEPARTMENT]: {
    name: 'Організаційна структура',
    instruction:
      'Опишіть загальну організаційну структуру, підкресливши, як різні відділи або підрозділи співпрацюють між собою для досягнення спільних цілей.',
    exampleOne: '',
    exampleTwo: '',
  },
};

const LEVEL3_DEPARTMENT_INSTRUCTIONS = {
  [LEVEL3_DEPARTMENT_NAMES.DEPARTMENT]: {
    name: 'Організаційна структура',
    instruction:
      'Опишіть загальну організаційну структуру, підкресливши, як різні відділи або підрозділи співпрацюють між собою для досягнення спільних цілей.',
    exampleOne: '',
    exampleTwo: '',
  },
};

const STAFF_ORGANIZATION_INSTRUCTIONS = {
  [STAFF_ORGANIZATION_NAMES.NUMBER_OF_STAFF]: {
    name: 'Кількість персоналу та структура',
    instruction:
      'Надайте загальну картину поточної кількості працівників у компанії. Укажіть загальну чисельність персоналу й коротко опишіть структуру штату, виділивши основні відділи або команди.',
    exampleOne:
      'У Компанії наразі працює 50 співробітників, розподілених між п’ятьма відділами: маркетинг і продажі, виробництво, HR, фінанси та дослідження й розробка.',
    exampleTwo:
      'У Компанії працює 12 співробітників у 3 відділах. Технічний відділ відповідає за розробку й підтримку платформи. Операційний відділ займається HR-активностями та маркетингом. Фінансовий відділ відповідає за управління фінансами.',
  },
  [STAFF_ORGANIZATION_NAMES.LEVEL1_DEPARTMENT]: {
    name: 'Організаційна структура',
    instruction:
      'Опишіть загальну організаційну структуру, підкресливши, як різні відділи або підрозділи співпрацюють між собою для досягнення спільних цілей.',
    exampleOne: '',
    exampleTwo: '',
  },
  [STAFF_ORGANIZATION_NAMES.LEVEL2_DEPARTMENT]: LEVEL2_DEPARTMENT_INSTRUCTIONS,
  [STAFF_ORGANIZATION_NAMES.LEVEL3_DEPARTMENT]: LEVEL3_DEPARTMENT_INSTRUCTIONS,
  [STAFF_ORGANIZATION_NAMES.SKILLS]: {
    name: 'Навички та кваліфікації',
    instruction:
      'Перерахуйте навички та кваліфікації, які, на вашу думку, потрібні співробітникам компанії для ефективного виконання своїх обов’язків. Включіть технічні навички, освіту та релевантний досвід. Будьте стислими й конкретними.',
    exampleOne:
      'Критично важливо, щоб співробітники мали диплом з механічної інженерії або еквівалентної спеціальності, досвід у проєктуванні важкої техніки, навички розв’язання проблем, знання сільськогосподарських практик, практичні комунікаційні навички, досвід командної роботи та розуміння екологічних норм.',
    exampleTwo:
      'Розробники платформи мають бути експертами в мовах програмування, таких як Python, JavaScript або Java. Вони повинні мати досвід розробки програмного забезпечення, володіти системами управління базами даних і розуміти хмарні платформи, як-от AWS чи Azure.',
  },
  [STAFF_ORGANIZATION_NAMES.ADDITIONAL_HIRES]: {
    name: 'Потреби в наймі',
    instruction:
      'Визначте, які саме фахівці й у якій кількості потрібні для реалізації проєкту. Опишіть ролі, навички та експертизу, необхідні для підтримки розвитку проєкту.',
    exampleOne:
      'Для реалізації проєкту потрібно найняти 15 нових співробітників. Планується набір 5 інженерів-розробників із досвідом проєктування сільськогосподарської техніки. Також необхідно найняти 10 технічних спеціалістів у виробничий відділ для підтримки зростання обсягів виробництва.',
    exampleTwo:
      'Заплановане розширення штату включає введення ролі Координатора проєкту для підтримки його розвитку. Ця особа відповідатиме за координацію активностей і управління документацією. Вимоги: сильні організаційні та комунікаційні навички, здатність працювати з кількома завданнями одночасно.',
  },
  [STAFF_ORGANIZATION_NAMES.APPROACHES]: {
    name: 'Підходи до рекрутингу',
    instruction:
      'Опишіть стратегії рекрутингу компанії. Назвіть відповідальних за процес найму. Наведіть перелік методів, які використовуються для залучення та відбору кандидатів, щоб забезпечити ґрунтовний і ефективний процес.',
    exampleOne:
      'За процес найму відповідає відділ кадрів (HR). Компанія використовує низку інструментів для оптимізації процесу, зокрема системи відстеження кандидатів (ATS) для управління вакансіями, заявками та комунікацією протягом усього циклу найму.',
    exampleTwo:
      'HR-менеджер Theodore Swift контролюватиме процес рекрутингу й онбордингу. HR-менеджер використовуватиме онлайн-портали з вакансіями та рекрутингове програмне забезпечення для ефективного залучення й попереднього відбору кандидатів.',
  },
  [STAFF_ORGANIZATION_NAMES.ATTRACTING_DIFFICULTIES]: {
    name: 'Складнощі із залученням персоналу',
    instruction:
      'Визначте труднощі, пов’язані з залученням персоналу. Це можуть бути невідповідність навичок, конкуренція на ринку праці, дефіцит кваліфікованих кадрів тощо. Коротко опишіть бар’єри, що можуть впливати на процес найму.',
    exampleOne:
      'Серед рекрутингових викликів — невідповідність навичок, обмежений пул талантів і конкуренція з іншими галузями. Висока технічна експертиза є критично важливою, однак пошук кваліфікованих кандидатів, особливо в сільській місцевості, залишається складним завданням.',
    exampleTwo:
      'Компанія стикається зі складнощами в залученні персоналу через високу конкуренцію за кваліфікованих фахівців на ринку праці. Талановиті спеціалісти часто висувають вищі вимоги до зарплати та соцпакета порівняно з іншими категоріями працівників.',
  },
  [STAFF_ORGANIZATION_NAMES.SALARY_POLICY]: {
    name: 'Оплата праці та мотивація',
    instruction:
      'Опишіть політику оплати праці щодо ринку. Розкажіть про наявні програми мотивації, включаючи бонуси, участь у прибутку й програми визнання. Зазначте, які показники результативності пов’язані зі стимулами.',
    exampleOne:
      'Зарплатна політика Компанії передбачає пропозицію зарплат вище середньориннього рівня для залучення найкращих фахівців. Додатково діють програми участі в прибутку для додаткової мотивації. Програми визнання досягнень і цілі, прив’язані до KPI, додатково стимулюють персонал.',
    exampleTwo:
      'Зарплатна політика Компанії відповідає ринковим стандартам і включає конкурентні компенсаційні пакети. Програми мотивації включають бонуси, залежні від результативності. Стимули прив’язано до індивідуальних і командних показників, що забезпечує узгодженість із цілями компанії.',
  },
  [STAFF_ORGANIZATION_NAMES.RETENTION_DIFFICULTIES]: {
    name: 'Проблеми з утриманням персоналу',
    instruction:
      'Опишіть проблеми, пов’язані з утриманням співробітників. Розкажіть про стратегії, що застосовуються для підвищення рівня утримання: конкурентна оплата праці, можливості професійного розвитку, інклюзивна корпоративна культура, програми визнання тощо.',
    exampleOne:
      'Серед викликів для Компанії — важкі фізичні умови праці та сезонні коливання навантаження. Для підвищення рівня утримання ми пропонуємо конкурентну компенсацію, професійний розвиток, інклюзивну культуру, програми визнання та підтримку балансу між роботою та особистим життям.',
    exampleTwo:
      'Складнощі з утриманням персоналу включають незадоволеність роботою та агресивні політики найму з боку конкурентів. Стратегії Компанії передбачають конкурентну оплату, можливості професійного зростання та формування інклюзивної корпоративної культури.',
  },
  [STAFF_ORGANIZATION_NAMES.DEVELOPMENT_PROGRAMS]: {
    name: 'Програми навчання та розвитку',
    instruction:
      'Детально опишіть програми розвитку та навчання персоналу. Укажіть методи навчання нових і чинних співробітників. Підкресліть важливість розвитку навичок працівників і їхній внесок у досягнення цілей організації.',
    exampleOne:
      'Компанія реалізовуватиме програми навчання й розвитку, щоб підготувати персонал до ефективного виконання обов’язків. Нові співробітники проходитимуть ґрунтовну програму онбордингу. Працівники матимуть доступ до безперервного навчання: воркшопів, семінарів, вебінарів та онлайн-курсів.',
    exampleTwo:
      'Компанія прагне реалізувати комплексну стратегію навчання. Регулярні воркшопи допоможуть розвинути навички управління проєктами, комунікації та обслуговування клієнтів. Працівники матимуть доступ до зовнішніх курсів і сертифікацій для подальшого поглиблення своєї експертизи.',
  },
};

export const MANAGEMENT_AND_ORGANIZATION_INSTRUCTIONS = {
  [BUSINESS_TOOL_SUB_SECTIONS.MANAGEMENT_AND_ORGANIZATION.MANAGEMENT_TEAM]: MANAGEMENT_TEAM_INSTRUCTIONS,
  [BUSINESS_TOOL_SUB_SECTIONS.MANAGEMENT_AND_ORGANIZATION.EXTERNAL_PARTNERS_AND_ADVISERS]:
    EXTERNAL_PARTNERS_AND_ADVISERS_INSTRUCTIONS,
  [BUSINESS_TOOL_SUB_SECTIONS.MANAGEMENT_AND_ORGANIZATION.STAFF_ORGANIZATION]: STAFF_ORGANIZATION_INSTRUCTIONS,
};
